import { Component } from '@angular/core';

@Component({
  selector: 'app-future-plan',
  templateUrl: './future-plan.component.html',
  styleUrls: ['./future-plan.component.scss']
})
export class FuturePlanComponent {

}
